/**
 * Mobile.js
 *
 * Mobile-only JavaScript functionality
 */
import "../vendor/dropit";

(function boot($) {
  var app = {};

  // Track mobile/desktop states
  app.mobileScripts = false;
  app.screenSize = false;

  // Initialize
  app.init = function () {
    var mobileQuery = matchMedia("only screen and (max-width: 929px)");
    var desktopQuery = matchMedia("only screen and (min-width: 930px)");

    function mobileMode() {
      app.enable();
      app.screenSize = "mobile";
    }

    function desktopMode() {
      app.disable();
      app.screenSize = "desktop";
    }

    if (mobileQuery.matches) mobileMode();
    if (desktopQuery.matches) desktopMode();

    mobileQuery.addListener(function (e) {
      if (e.matches) mobileMode();
    });

    desktopQuery.addListener(function (e) {
      if (e.matches) desktopMode();
    });

    // Remove links for top level dropdown menu items
    $("#primary-menu > li.menu-item-has-children > a").removeAttr("href");
  };

  // Enable dropdown menus
  app.enableDesktopDropdowns = function () {
    $("#primary-menu").dropit({
      action: "mouseenter focus",
      triggerEl: "a, button",
      afterHide: function ($el) {
        $el.prop("aria-expanded", false);
      },
      afterShow: function ($el) {
        $el.prop("aria-expanded", true);
      },
    });
  };

  // Disable dropdown menus
  app.disableDesktopDropdowns = function () {
    $(".site-header__menus *").off();

    // Remove classes
    $(".dropit-open").removeClass("dropit-open");
    $(".dropit-submenu").removeClass("dropit-submenu").hide();
    $(".dropit").removeClass("dropit");
    $(".dropit-trigger").removeClass("dropit-trigger");

    $(".site-header .sub-menu").hide();
  };

  // Turn mobile handlers ON
  app.enable = function () {
    if (app.mobileScripts == "enabled") return;

    console.info("Mobile device support enabled.");
    app.mobileScripts = "enabled";
    app.disableDesktopDropdowns();
    $("body").addClass("mobile-menu-closed");
    $(".site-header__menus").hide();

    $(document).on("click", '[data-open="site-header__menus"]', app.mainMenuToggle);
    $(document).on("click", "#primary-menu > li > a, #primary-menu > li > button", app.subMenuToggle);
  };

  // Turn mobile handlers OFF
  app.disable = function () {
    if (app.mobileScripts == "disabled") return;

    app.mobileScripts = "disabled";
    app.enableDesktopDropdowns();

    $(".site-header__menus").show();
    $(document).off("click", '[data-open="site-header__menus"]', app.mainMenuToggle);
    $(document).off("click", "#primary-menu > li > a, #primary-menu > li > button", app.subMenuToggle);
  };

  // Main menu click/tap handlers
  app.mainMenuToggle = function (event) {
    event.preventDefault();
    event.stopPropagation();
    $(this).toggleClass("open");
    const isOpen = $(this).hasClass("open");
    if (isOpen) {
      $(".site-header__menus").show();
      $("body").addClass("mobile-menu-open");
      $("body").removeClass("mobile-menu-closed");
    } else {
      $(".site-header__menus").hide();
      $("body").removeClass("mobile-menu-open");
      $("body").addClass("mobile-menu-closed");
    }
  };

  // Turn mobile handlers OFF
  app.subMenuToggle = function (e) {
    e.preventDefault();

    var parent = $(this).parent("li");
    var all = $("#primary-menu > li");

    // No sub-menu, go to page
    if (!parent.find(".sub-menu").length) {
      window.location.href = $(this).attr("href");
      return;
    }

    // If click is on an active menu item then go to page
    if (parent.is(".active")) {
      parent.removeClass("active");
      parent.find(".sub-menu").stop().hide();
      return;
    }

    // De-activate existing active menus
    all.removeClass("active");
    all.find(".sub-menu").stop().hide();

    // Make this menu item active
    parent.toggleClass("active");
    parent.find(".sub-menu").stop().toggle();
  };

  app.init();
})(window.jQuery);
